import { Address } from "@/types/common.type";

const getAddressString = function(address: Address): string {
  if (address.address2) {
    return `${address.address1} ${address.address2}, ${address.city}, ${address.state}, ${address.zipCode}`;
  } 
  else {
    return `${address.address1}, ${address.city}, ${address.state}, ${address.zipCode}`;
  }
}

export { getAddressString };